import React from "react";
import { reduxForm, Field } from "redux-form";

import Textarea from "../../../../components/common/textarea/Textarea";
import Button from "../../../../components/common/button/Button";
import { ADMIN_SEND_NOTE_FORM } from "../../../../actions/admin.actions";

import styles from "./SendForm.scss";

class SendForm extends React.Component {
  render() {
    const { handleSubmit, invalid, submitting, pristine } = this.props;

    return (
      <form className={styles.sendForm} onSubmit={handleSubmit}>
        <div className={styles.doubleDivider} />

        <div className={styles.sendFormContent}>
          <div className={styles.form}>
            <div className={styles.input}>
              <Field
                name="note"
                type="textarea"
                placeholder="Write a note"
                component={Textarea}
                disableCounter={true}
              />
            </div>
          </div>

          <div className={styles.button}>
            <Button
              type="submit"
              isDisabled={invalid || submitting || pristine}
              label="SEND"
            />
          </div>
        </div>
      </form>
    );
  }
}

SendForm = reduxForm({
  form: ADMIN_SEND_NOTE_FORM
})(SendForm);

export default SendForm;



// WEBPACK FOOTER //
// ./src/routes/common/adminNotes/SendForm/SendForm.js